<template>
  <div
    class="col-auto row justify-start items-start q-pt-sm"
  >
    <div
      v-for="activity in availableActivities"
      :key="activity.id"
      class="col-sm-4 col-xs-6 full-height q-px-sm q-pb-md"
      style="display: flex; flex-direction: column;"
    >
      <q-card
        flat
        bordered
        style="height: 100%;"
        class="full-width full-height"
        :class="{ 'rounded-borders-8 overflow-hidden': !$register }"
        :data-test-id="`activity-space-${activity.name}`"
        @click="handleActivityClick(activity)"
      >
        <div>
          <transition
            leave-class="hidden"
            enter-active-class="animated bounceIn"
          >
            <q-badge
              v-if="activityBookingsCount(activity)"
              :key="activityBookingsCount(activity)"
              style="font-size: 18px; z-index: 1"
              class="q-py-sm text-bold"
              :color="hideImage ? 'secondary' : 'primary'"
              :text-color="badgeTextColor"
              floating
            >
              x {{ activityBookingsCount(activity) }}
            </q-badge>
          </transition>
        </div>
        <q-img
          :src="activity.bannerImageUrl"
          :no-spinner="true"
          :no-transition="true"
        />
        <q-card-section class="q-pa-sm">
          <div class="text-center text-bold">
            {{ activity.name }}
          </div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import { useAvailableActivities } from 'src/modules/checkout/composables/activity-availability/AvailableActivities'
export default {
  name: 'ActivitiesGrid',
  inject: ['order'],
  configuration: ['activities'],
  emits: ['activity-selected'],
  setup () {
    const { computeAvailableActivities } = useAvailableActivities()
    return {
      computeAvailableActivities
    }
  },
  computed: {
    availableActivities () {
      return this.computeAvailableActivities(this.activities.data)
    }
  },
  methods: {
    activityBookingsCount (activity) {
      return _.filter(this.order.activityBookings.data, { activity: { id: activity.id } }).length
    },
    handleActivityClick (activity) {
      this.$emit('activity-selected', activity)
    }
  }
}
</script>
